<ng-container *transloco="let t; read: 'partials.agenda.participant_icons'">
  <ng-container *ngIf="auth.isModerator()">
    <span class="">
      <fa-icon *ngIf="mode === null && slot?.for_candidate === true" [icon]="faStreetView" class="p-ml-2"></fa-icon>
      <fa-icon *ngIf="mode === null && slot?.for_observer === true" [icon]="faUsers" class="p-ml-2"></fa-icon>
      <fa-icon *ngIf="mode === 'rating'" [icon]="faUsers" class="p-ml-2"></fa-icon>
    </span>
  </ng-container>
</ng-container>
